import { useState } from 'react';
import { faqItems } from '@/mocks/books';
import { useInView } from '@/hooks/useInView';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { ref, inView } = useInView();

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const anim = (inView: boolean) =>
    `transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`;

  return (
    <section className="min-h-[100svh] flex items-center py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div ref={ref} className={`max-w-3xl mx-auto w-full ${anim(inView)}`}>
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 text-center mb-12">
          常見問答
        </h2>

        <div className="flex flex-col gap-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left transition-colors hover:bg-background-100"
              >
                <h3 className="font-label font-medium text-base text-foreground-950 pr-4">
                  {item.q}
                </h3>
                <span className={`flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-lg text-foreground-500"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <p className="px-6 text-base text-foreground-500 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}